const Grid = () => {
  return {
    MuiGrid: {
      styleOverrides: {
        root: ({ theme: _theme }) => ({
          backgroundColor: 'inherit'//theme.palette.background.paper
        })
      }
    }
  }
}

export default Grid
